(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["premier-category-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.premier-cat-expand').forEach(function (wrap) {
    var btn = wrap.querySelector('[data-pcx-toggle]');
    var labelEl = wrap.querySelector('[data-pcx-label]');
    if (!btn) return;
    var initialLabel = labelEl ? labelEl.textContent.trim() : '';
    var collapseLabel = wrap.getAttribute('data-pcx-collapse-label') || 'Show fewer';

    btn.addEventListener('click', function () {
      var expanded = wrap.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (labelEl) labelEl.textContent = expanded ? collapseLabel : initialLabel;
      if (!expanded) {
        // Scroll back to button so it stays in view after collapse
        wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    btn.setAttribute('aria-expanded', 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvy-feeder-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!root) return;

    // Variant tooltips: read JSON map, wire hover/select on pills
    var tipsScript = document.querySelector('[data-svfl-variant-tips="{{ section.id }}"]');
    var tips = {};
    try { tips = JSON.parse(tipsScript.textContent); } catch (e) {}
    var helper = root.querySelector('[data-svfl-helper]');
    var pills = root.querySelectorAll('[data-svfl-variant]');

    function showTipFor(variantId) {
      if (!helper) return;
      helper.innerHTML = tips[variantId] || tips['default'] || '';
    }
    function selectedVariantId() {
      var sel = root.querySelector('[data-svfl-variant]:checked');
      return sel ? sel.value : '';
    }
    // Init with currently-selected variant
    showTipFor(selectedVariantId());

    pills.forEach(function (input) {
      var label = input.closest('.svfl-pdp__pill');
      if (!label) return;
      label.addEventListener('mouseenter', function () { showTipFor(input.value); });
      label.addEventListener('mouseleave', function () { showTipFor(selectedVariantId()); });
      input.addEventListener('change', function () {
        // Update pill styles
        root.querySelectorAll('.svfl-pdp__pill').forEach(function (p) { p.classList.remove('is-selected'); });
        label.classList.add('is-selected');
        showTipFor(input.value);
      });
    });

    // Quantity +/- buttons
    var qtyInput = root.querySelector('[data-svfl-qty-input]');
    root.querySelectorAll('[data-svfl-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var delta = parseInt(btn.getAttribute('data-svfl-qty'), 10) || 0;
        var current = parseInt(qtyInput.value, 10) || 1;
        var next = Math.max(1, current + delta);
        qtyInput.value = next;
      });
    });

    // Thumbnail click swaps main image
    var mainMedia = root.querySelector('[data-svfl-main-img]');
    var thumbs = root.querySelectorAll('[data-svfl-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        if (!img || !mainMedia) return;
        // Build a larger image URL from the thumb src (replace width param)
        var src = img.getAttribute('src');
        var large = src.replace(/width=\d+/, 'width=1200');
        mainMedia.setAttribute('src', large);
        mainMedia.setAttribute('alt', img.getAttribute('alt') || '');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvy-feeder-videos"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.svfl-video__media[data-svfl-yt]').forEach(function (media) {
    var yt = media.getAttribute('data-svfl-yt');
    if (!yt) return;
    var btn = media.querySelector('[data-svfl-play]');
    function play() {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(yt) + '?autoplay=1&rel=0&modestbranding=1';
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');
      media.appendChild(iframe);
      media.classList.add('is-playing');
    }
    if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); play(); });
    media.addEventListener('click', function (e) {
      if (media.classList.contains('is-playing')) return;
      if (e.target.closest('[data-svfl-play]')) return;
      play();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvy-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.savvy-header').forEach(function (header) {
    var drawer = header.querySelector('[data-savvy-drawer]');
    var backdrop = header.querySelector('.sh-drawer-backdrop');
    var burgers = header.querySelectorAll('[data-savvy-header-burger]');

    function toggleDrawer(open) {
      var willOpen = open !== undefined ? open : !drawer.classList.contains('is-open');
      drawer.classList.toggle('is-open', willOpen);
      drawer.setAttribute('aria-hidden', !willOpen);
      backdrop.classList.toggle('is-open', willOpen);
      document.body.style.overflow = willOpen ? 'hidden' : '';
    }
    burgers.forEach(function (b) { b.addEventListener('click', function () { toggleDrawer(); }); });

    // Expandable drawer items
    header.querySelectorAll('[data-savvy-drawer-expand] .sh-drawer-link').forEach(function (link) {
      link.addEventListener('click', function () {
        link.parentElement.classList.toggle('is-open');
      });
    });

    // Sticky scroll-up behaviour
    if (header.classList.contains('savvy-header-sticky-scroll-up')) {
      var lastY = window.scrollY;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (y > 100 && y > lastY) header.classList.add('is-hidden');
        else header.classList.remove('is-hidden');
        lastY = y;
      }, { passive: true });
    }

    // Update cart count when Shopify cart changes (best-effort, fetches /cart.js)
    var cartCount = header.querySelector('[data-savvy-cart-count]');
    if (cartCount) {
      document.addEventListener('cart:updated', function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cartCount.textContent = c.item_count; });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvy-home-bestsellers"] && !Shopify.designMode) return;
  try {
    
  // Bestsellers quick-buy — variant picker + AJAX add to cart
  document.querySelectorAll('.savvy-home-bestsellers').forEach(function (section) {
    section.querySelectorAll('[data-savvy-bs-card]').forEach(function (card) {
      var form = card.querySelector('[data-savvy-bs-form]');
      var variantInput = card.querySelector('[data-savvy-bs-variant]');
      var variantsScript = card.querySelector('[data-savvy-bs-variants]');
      var addBtn = card.querySelector('[data-savvy-bs-add]');
      var variants = variantsScript ? JSON.parse(variantsScript.textContent) : null;

      // When a pill is selected, find the matching variant and update card UI
      var imageEl = card.querySelector('[data-savvy-bs-image]');
      var priceCurrentEl = card.querySelector('[data-savvy-bs-price-current]');
      var priceCompareEl = card.querySelector('[data-savvy-bs-price-compare]');
      var moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

      function formatMoneyCents(cents) {
        // Use Shopify's formatMoney helper if available, otherwise fall back to simple USD.
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return '$' + (cents / 100).toFixed(2);
      }

      function updateCardForVariant(match) {
        // Update hidden cart-add variant ID
        variantInput.value = match.id;

        // Update image — variant.featured_image if set, else leave default
        if (imageEl && match.featured_image && match.featured_image.src) {
          var src = match.featured_image.src;
          // Shopify variant.featured_image.src is a full URL with no size suffix; we don't refactor it
          // to image_url since this is runtime JS — the browser will load whatever resolution is in the variant image
          imageEl.src = src;
          imageEl.removeAttribute('srcset'); // browser falls back to src
          if (match.featured_image.alt) imageEl.alt = match.featured_image.alt;
        } else if (imageEl) {
          // Reset to product default if variant has no specific image
          var defaultSrc = imageEl.getAttribute('data-default-src');
          if (defaultSrc) imageEl.src = defaultSrc;
        }

        // Update price
        if (priceCurrentEl) priceCurrentEl.textContent = formatMoneyCents(match.price);
        if (priceCompareEl && match.compare_at_price && match.compare_at_price > match.price) {
          priceCompareEl.textContent = formatMoneyCents(match.compare_at_price);
          priceCompareEl.style.display = '';
        } else if (priceCompareEl) {
          priceCompareEl.style.display = 'none';
        }
      }

      card.querySelectorAll('input[type="radio"][data-savvy-bs-option-value]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!variants) return;
          var selectedValue = radio.value;
          // Match the FIRST variant whose option1 value matches (we only show option1 inline)
          var match = variants.find(function (v) { return v.option1 === selectedValue && v.available; });
          if (match) {
            updateCardForVariant(match);
            addBtn.disabled = false;
          } else {
            // Try non-available variants too so we can disable button properly
            var anyMatch = variants.find(function (v) { return v.option1 === selectedValue; });
            if (anyMatch) {
              updateCardForVariant(anyMatch);
              addBtn.disabled = true;
            }
          }
        });
      });

      // AJAX submit
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var originalLabel = addBtn.querySelector('.sh-bs-add-label').textContent;
        addBtn.disabled = true;
        addBtn.querySelector('.sh-bs-add-label').textContent = 'Adding...';

        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        }).then(function (r) { return r.json(); }).then(function (data) {
          if (data.status) { throw new Error(data.description || 'Error'); }
          form.classList.add('is-added');
          addBtn.querySelector('.sh-bs-add-label').textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            form.classList.remove('is-added');
            addBtn.querySelector('.sh-bs-add-label').textContent = originalLabel;
            addBtn.disabled = false;
          }, 1800);
        }).catch(function (err) {
          addBtn.querySelector('.sh-bs-add-label').textContent = originalLabel;
          addBtn.disabled = false;
          console.error('[Savvy bestsellers] add-to-cart failed:', err);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvy-home-hero"] && !Shopify.designMode) return;
  try {
    
  // Hero badge: dismiss handler (per-session via sessionStorage)
  document.querySelectorAll('.sh-hero-badge[data-badge-dismissable="true"]').forEach(function (badge) {
    var id = badge.closest('.savvy-home-hero').id || 'savvy-hero';
    var key = 'sh_badge_dismissed_' + id;
    if (sessionStorage.getItem(key)) { badge.style.display = 'none'; return; }
    var btn = badge.querySelector('.sh-hero-badge-close');
    if (btn) btn.addEventListener('click', function () {
      sessionStorage.setItem(key, '1');
      badge.style.display = 'none';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvy-product-grid-expandable"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.savvy-pg').forEach(function (section) {
    var btn = section.querySelector('[data-savvy-pg-expand]');
    var labelEl = section.querySelector('[data-savvy-pg-expand-label]');
    if (!btn) return;

    var initialLabel = labelEl ? labelEl.textContent : '';
    // Read collapse label from a data attribute on the section element.
    // Section-level JS must be static, so dynamic values come through data-* attributes.
    var collapseLabel = section.getAttribute('data-collapse-label') || 'Show fewer';

    btn.addEventListener('click', function () {
      var expanded = section.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (labelEl) {
        labelEl.textContent = expanded ? collapseLabel : initialLabel;
      }
      if (!expanded) {
        // Scroll back to section top when collapsing so user doesn't end up below the fold
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    // Initial aria state
    btn.setAttribute('aria-expanded', 'false');
  });

  } catch(e) { console.error(e); }
})();
})();
